import { jsx as _jsx } from "react/jsx-runtime";
function CaretUpRightCaretDownLeftToCenter({ className, size = 24, }) {
    return (_jsx("svg", { className: className, width: size, height: size, viewBox: "0 0 32 32", fill: "currentColor", children: _jsx("path", { d: "M14.788 17.212v7.273h-2.424v-4.849H7.515v-2.424h7.273zm4.848-9.697v4.849h4.849v2.424h-7.273V7.515h2.424z" }) }));
}
export default CaretUpRightCaretDownLeftToCenter;
